module.exports = __webpack_public_path__ + "5d142117bb18f67ce15a5dbd00aeedc0.jpg";